import { z } from "zod"

export const addressStringSchema = z.object({
  addressString: z.string(),
})

export const addressItemsSchema = z.object({
  address1: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  country: z.string(),
})

export const latLonSchema = z.object({
  lon: z.number(),
  lat: z.number(),
})

export const genabilityAddressSchema = z.union([
  addressStringSchema,
  addressItemsSchema,
  latLonSchema,
])

export type GenabilityAddress = z.infer<typeof genabilityAddressSchema>
